if (!customElements.get('cs-skandi')) customElements.define('cs-skandi', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
    this.filter = 'all'; this.expanded = false;
    this.cards = [...this.querySelectorAll('.sk-product')];
    this.dialog = this.querySelector('.sk-dialog');
    this.querySelectorAll('.sk-toolbar,.sk-product-peek').forEach(e => e.hidden = false);
    this.classList.add('is-ready'); this.setMood('1'); this.filterCards();
    this.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      if (b.dataset.mood) this.setMood(b.dataset.mood);
      if (b.dataset.filter) { this.filter = b.dataset.filter; this.expanded = false; this.filterCards(); }
      if (b.hasAttribute('data-more')) { this.expanded = !this.expanded; this.filterCards(); }
      if (b.dataset.productId) this.openProduct(b.dataset.productId, b);
      if (b.classList.contains('sk-dialog-close')) this.dialog.close();
    }, {signal});
    this.dialog?.addEventListener('click', e => { if (e.target === this.dialog) {const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}}, {signal});
    this.dialog?.addEventListener('close', () => this.returnFocus?.focus({preventScroll:true}), {signal});
    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.updatePosition(); });
    };
    window.addEventListener('scroll',this.onScroll,{signal,passive:true});
    window.addEventListener('resize',this.onScroll,{signal,passive:true});
    document.addEventListener('shopify:block:select', e => {if(this.contains(e.target))e.target.scrollIntoView({block:'start',behavior:'instant'});},{signal});
    this.updatePosition();
  }
  disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.frame); this.frame = 0; this.dialog?.close(); }
  setMood(id) {
    this.querySelectorAll('[data-mood]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mood === id)));
    this.querySelectorAll('[data-mood-panel]').forEach(p => p.hidden = p.dataset.moodPanel !== id);
  }
  filterCards() {
    const matches = this.cards.filter(c => this.filter === 'all' || c.dataset.category === this.filter);
    this.cards.forEach(c => c.hidden = !matches.includes(c) || (!this.expanded && matches.indexOf(c) >= 6));
    this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.filter === this.filter)));
    const count=this.querySelector('[data-count]'); if(count)count.textContent = `${this.expanded ? matches.length : Math.min(6,matches.length)} von ${matches.length} Stücken`;
    const more=this.querySelector('[data-more]'); if(more){more.hidden=matches.length<=6;more.setAttribute('aria-expanded',String(this.expanded));more.innerHTML=this.expanded?'Weniger Stücke anzeigen <span aria-hidden="true">−</span>':'Weitere Lieblingsstücke ansehen <span aria-hidden="true">+</span>';}
  }
  openProduct(id,trigger) {
    const t=this.querySelector(`template[data-product-template="${CSS.escape(id)}"]`);if(!t||!this.dialog)return;
    const read=key=>t.content.querySelector(`[data-part="${key}"]`);
    this.dialog.querySelector('[data-dialog-image]').replaceChildren(...[...read('image').childNodes].map(n=>n.cloneNode(true)));
    for(const key of ['title','vendor','price','availability'])this.dialog.querySelector(`[data-dialog-${key}]`).textContent=read(key).textContent;
    this.dialog.querySelector('[data-dialog-link]').href=read('url').href;
    this.returnFocus=trigger;this.dialog.showModal();
  }
  updatePosition() {
    const header=document.querySelector('#SiteHeader,.site-header');let offset=0;
    if(header){const r=header.getBoundingClientRect();const style=getComputedStyle(header);if(r.top<=1&&r.bottom>0&&(style.position==='sticky'||style.position==='fixed'||header.closest('.site-header-sticky')))offset=r.bottom;}
    this.style.setProperty('--sk-header',`${Math.max(0,offset)}px`);
    const r=this.getBoundingClientRect();const progress=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-innerHeight)));
    const bar=this.querySelector('.sk-progress');if(bar)bar.style.width=`${progress*100}%`;
    const links=[...this.querySelectorAll('.sk-chapters a')];let active=links[0];
    for(const link of links){const target=document.getElementById(link.hash.slice(1));if(target&&target.getBoundingClientRect().top<=offset+120)active=link;}
    links.forEach(a=>a===active?a.setAttribute('aria-current','location'):a.removeAttribute('aria-current'));
  }
});
